import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import styles from './LevelBadge.module.css';
import { getLevelBadge } from './LevelBadges';
import LevelPanel from './LevelPanel';

const LEVELS = [
    { name: 'Beginner', xp: 0 },
    { name: 'Novice', xp: 500 },
    { name: 'Intermediate', xp: 2000 },
    { name: 'Advanced', xp: 5000 },
    { name: 'Proficient', xp: 10000 },
    { name: 'Expert', xp: 18000 },
    { name: 'Elite', xp: 28000 },
    { name: 'Master', xp: 40000 },
    { name: 'Grandmaster', xp: 55000 },
    { name: 'Legendary', xp: 75000 }
];

const LevelBadge = () => {
    const [isPanelVisible, setIsPanelVisible] = useState(false);
    const { user } = useAuth();
    const badgeRef = useRef(null);
    
    const totalXp = user?.total_xp || 0;
    
    // Find the current level based on XP
    const getCurrentLevel = (xp) => {
        return LEVELS.reduce((prev, curr) => {
            if (xp >= curr.xp) return curr;
            return prev;
        }, LEVELS[0]);
    };
    
    const currentLevel = getCurrentLevel(totalXp);
    
    const togglePanel = () => {
        setIsPanelVisible(!isPanelVisible);
    };
    
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (badgeRef.current && !badgeRef.current.contains(event.target)) {
                setIsPanelVisible(false);
            }
        };
        
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    
    return (
        <div className={styles.levelBadgeContainer} ref={badgeRef}>
            <button 
                className={styles.iconButton} 
                onClick={togglePanel}
                aria-label={`Your level: ${currentLevel.name}`}
                title={`Your level: ${currentLevel.name}`}
            >
                {getLevelBadge(currentLevel.name, 40)}
            </button>
            {isPanelVisible && (
                <LevelPanel 
                    isVisible={isPanelVisible} 
                    onClose={() => setIsPanelVisible(false)} 
                />
            )}
        </div>
    );
};

export default LevelBadge;